import { SIMPLDialog } from "~/components/commons/dialog/SimplDialog";
import { SIMPLButtonCustomized } from "~/components/commons/button/SIMPLButtonCustumized";

interface Props {
  onCloseModal: () => void;
  item: { name: string; content: string };
}

export const ViewContentModal = ({ onCloseModal, item }: Props) => {
  const renderButtons = () => (
    <div className="grow-0 basis-32">
      <SIMPLButtonCustomized label="Cerrar" secondary buttonHandlerAction={onCloseModal} />
    </div>
  );

  return (
    <SIMPLDialog
      onCloseModal={onCloseModal}
      title={`Contenido: ${item.name}`}
      actions={renderButtons()}
    >
      <div className="w-[700px] max-h-[500px] overflow-auto">
        <pre className="bg-gray-100 rounded p-4 text-sm text-gray-800 whitespace-pre-wrap break-words font-mono">
          {item.content || "— Sin contenido —"}
        </pre>
      </div>
    </SIMPLDialog>
  );
};
